import './AgentOsWave.css';

// AgentOS loading wave (Alex 2026-07-15) — replaces the generic circle spinner
// with the brand's amber voice-wave: five bars pulsing in a travelling wave.
// Same visual language as the mic/wave icon Alex likes; pure CSS, accent-driven,
// respects prefers-reduced-motion (static bars there).
export function AgentOsWave({ label, size = 'md' }: { label?: string; size?: 'sm' | 'md' | 'lg' }) {
  return (
    <div className={`aos-wave aos-wave-${size}`} role="status" aria-label={label || 'Lädt…'}>
      <div className="aos-wave-bars" aria-hidden="true">
        <span /><span /><span /><span /><span />
      </div>
      {label && <span className="aos-wave-label">{label}</span>}
    </div>
  );
}
